export const FONTS = ["Cormorant Garamond", "Playfair Display", "DM Serif Display", "Bodoni Moda", "Fraunces", "Lora", "Merriweather", "Cinzel", "Marcellus", "Italiana", "Abril Fatface",
  "Bebas Neue", "Syne", "Bricolage Grotesque", "Space Grotesk", "Manrope", "DM Sans", "Outfit", "Figtree", "Work Sans", "Karla", "IBM Plex Sans", "Poppins", "Montserrat",
  "Raleway", "Josefin Sans", "Jost", "Nunito", "Dancing Script", "Great Vibes"];
const SINGLE = new Set(["DM Serif Display", "Marcellus", "Italiana", "Abril Fatface", "Bebas Neue", "Great Vibes"]);
export const WEIGHTS = [[300, "Light"], [400, "Regular"], [500, "Medium"], [600, "Semi-bold"], [700, "Bold"], [800, "Extra-bold"], [900, "Black"]];

export function ensureFont(f) {
  if (!f || !FONTS.includes(f) || typeof document === "undefined") return;
  const id = "tt-font-" + f.replace(/\s/g, "");
  if (document.getElementById(id)) return;
  const l = document.createElement("link");
  l.id = id;
  l.rel = "stylesheet";
  l.href = `https://fonts.googleapis.com/css2?family=${f.replace(/ /g, "+")}${SINGLE.has(f) ? "" : ":wght@400;500;600;700"}&display=swap`;
  document.head.appendChild(l);
}

export function tstyle(ts, ctx) {
  if (!ts) return undefined;
  const o = {};
  const n = Number(ts.size);
  if (n > 0) o.fontSize = `${ctx?.device === "mobile" && n > 28 ? Math.round(n * 0.7) : n}px`;
  if (n > 0) o.lineHeight = n > 28 ? 1.1 : 1.5;
  if (ts.weight) o.fontWeight = Number(ts.weight);
  if (ts.font) { ensureFont(ts.font); o.fontFamily = `'${ts.font}', sans-serif`; }
  if (ts.color) o.color = ts.color;
  if (ts.italic) o.fontStyle = "italic";
  if (ts.upper) o.textTransform = "uppercase";
  return o;
}

export const T = (s, k, ctx) => tstyle(s?._ts?.[k], ctx);
